<template>
    <div class="sidebar">
        <ul class="side-nav">
            <router-link to="/admin" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/9a.svg" class="img-sidbar" />
                    <span>Dashboard</span>
                </li>
            </router-link>
            <router-link to="/nsb-baru" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/1a.svg" class="img-sidbar" />
                    Nasabah Baru
                </li>
            </router-link>
            <router-link to="/nsb-terdaftar" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/4a.svg" class="img-sidbar" />
                    Nasabah Terdaftar
                </li>
            </router-link>
            <router-link to="/nsb-reject" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/2a.svg" class="img-sidbar" />
                    Nasabah Reject
                </li>
            </router-link>
            <router-link to="/nsb-blacklist" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/3a.svg" class="img-sidbar" />
                    <span>Nasabah Blacklist</span>
                </li>
            </router-link>
            <router-link to="/nsb-deposit" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/10a.svg" class="img-sidbar" />
                    <span>Nasabah Deposit</span>
                </li>
            </router-link>
            <router-link to="/nsb-withdrawal" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/9a.svg" class="img-sidbar" />
                    <span>Nasabah Withdrawal</span>
                </li>
            </router-link>
            <router-link to="/list-user" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/8a.svg" class="img-sidbar img-sidbar-square" />
                    <span>Daftar User</span>
                </li>
            </router-link>
            <router-link to="/audit-trail" class="link">
                <li class="side-nav-link">
                    <img src="@/assets/icons/8a.svg" class="img-sidbar img-sidbar-square" />
                    <span>Audit Trail</span>
                </li>
            </router-link>

            <li @click="logout" class="side-nav-link"><img src="@/assets/icons/5b.svg" class="img-sidbar img-sidbar-square" />Logout</li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            current: "",
            hover: false,
        };
    },
    methods: {
        toggle(e) {
            var elems = document.getElementsByClassName("sub-menu");
            if (elems[e].classList.value === "sub-menu") {
                elems[e].classList.add("active-menu");
            } else {
                elems[e].classList = "sub-menu";
            }
        },
        logout() {
            this.$store.dispatch("logout").then(() => {
                this.$router.go("/home");
            });
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
    },
};
</script>

<style scoped>
.sidebar {
    width: 219px;
}

a .router-link-exact-active,
.router-link-active .side-nav-link {
    background-color: rgba(230, 230, 230, 0.25);
    color: #6454f0;
    position: relative;
}

a .router-link-exact-active,
.router-link-active .side-nav-link::before {
    content: "";
    position: absolute;
    width: 5px;
    height: 100%;
    background: #6454f0;
    left: 0;
    top: 0px;
}

.side-nav {
    margin-top: 1rem;
    padding: 1rem 0;
}

.side-nav-link {
    list-style: none;
    align-items: center;
    font-size: 14px;
    padding: 1rem 1.5rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
    color: #707070;
}

.side-nav-link:hover {
    background-color: rgba(230, 230, 230, 0.25);
    /* position: relative; */
}

.sub-menu {
    padding: 0 0 0 15px;
    display: none;
    transition: ease-out 0.5s;
}

.active-menu {
    display: block;
}

.link:hover {
    text-decoration: none;
}

.icon-sidebar {
    font-size: 20px;
    margin-right: 10px;
}

.img-sidbar {
    width: 20px;
    margin-right: 10px;
    vertical-align: text-top;
}

.img-sidbar-square {
    width: 15px;
    margin-right: 10px;
    vertical-align: text-top;
}

.menu-eksternal {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
